import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import "./Partenaires.css";

import img1 from "../../../images/Partenaires/p1.jpeg";
import img2 from "../../../images/Partenaires/p2.jpeg";
import img3 from "../../../images/Partenaires/p3.jpeg";

export default function Partenaires({ navigateWithTransition }) {
  const [activeDialog, setActiveDialog] = useState(null);
const sectionRef = useRef(null);

useEffect(() => {
  const section = sectionRef.current;
  if (!section) return;

  const elements = section.querySelectorAll(".reveal-on-scroll");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -8% 0px",
    }
  );

  elements.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}, []);
  const partenaires = [
    "Ahmed majdoub",
    "Abir turki",
    "Fidaa chaabene",
    "Wiem bouzgenda",
    "Hamed jouina",
    "Mohamed khemakhem",
    "Hamed jouini",
    "Melek layouni",
    "Maha azaiez",
    "Wajdi turki",
    "Hamdi turki",
    "Radhi makni",
  ];

 const dialogContent = {
  electromenagers: {
    title: "ÉLECTROMÉNAGERS",
    text: (
      <>
        <strong>WHIRLPOOL :</strong> Spécialiste de l’électroménager haut de gamme et marque 
reconnue à l’international, WHIRLPOOL fournit des électroménagers qui se 
marient parfaitement à nos designs, apportant à la fois performance et 
élégance à nos réalisations.

        <br /><br />

        <strong>PROMODAR :</strong> : Un showroom proposant un large choix d’électroménager pour 
toutes les gammes et tous les budgets, allant des marques les plus 
prestigieuses et haut de gamme telles que Falmec et Franke, aux références 
offrant un excellent rapport qualité/prix comme Rosières, Gorenje et enfin 
Infinity

        <br /><br />

        <strong>FOCUS :</strong> est une marque tunisienne d’électroménager proposant des produits 
modernes, fonctionnels et accessibles. Elle se distingue par un bon rapport 
qualité/prix et une gamme variée adaptée aux besoins du quotidien. 
Partenaire par catégorie
      </>
    ),
  },

 materiaux: {
  title: "MATÉRIAUX ET PIERRE DE SURFACE",
  text: (
    <>
      <strong>MPBS :</strong> MPBS est une entreprise tunisienne spécialisée dans les panneaux 
dérivés du bois pour le mobilier et l’aménagement intérieur. Elle propose des 
solutions durables et esthétiques adaptées aux professionnels de la cuisine et 
de l’agencement. 

      <br /><br />

      <strong>LAMINAM :</strong> est une marque italienne spécialisée dans les grandes surfaces en 
grès cérame. Elle propose des matériaux haut de gamme, résistants et 
esthétiques, utilisés notamment pour les plans de travail et l’aménagement 
intérieur. Ses produits se distinguent par leur finesse, leur durabilité et leur 
design contemporain. 

      <br /><br />

      <strong>INFINITY :</strong> est une marque italienne spécialisée dans les surfaces en grès cérame 
grand format pour les plans de travail et l’aménagement intérieur. Elle propose 
des matériaux élégants, résistants et faciles d’entretien, alliant performance 
technique et design contemporain.

      <br /><br />

      <strong>SILESTONE :</strong> est une marque espagnole spécialisée dans les surfaces en quartz 
pour les plans de travail et l’aménagement intérieur. Elle se distingue par ses 
matériaux résistants, hygiéniques et esthétiques, disponibles dans une large 
variété de finitions et de couleurs. 

      <br /><br />

      <strong>DEKTON :</strong>  est une marque espagnole spécialisée dans les surfaces ultra
compactes pour les plans de travail et l’aménagement intérieur. Elle propose 
des matériaux très résistants à la chaleur, aux rayures et aux UV, alliant haute 
performance et design contemporain.
      <br /><br />

      <strong>ABET LAMINATI :</strong> est une marque italienne spécialisée dans les surfaces en 
HPL (stratifié haute pression) pour le mobilier et l’aménagement intérieur. Elle 
propose 
des matériaux résistants, décoratifs et faciles d’entretien, adaptés aux plans de 
travail et aux usages intensifs.
    </>
  ),
},

 accessoires: {
  title: "ACCESSOIRES & QUINCAILLERIE",
  text: (
    <>
      <strong>BLUM :</strong> est une marque autrichienne spécialisée dans les ferrures et systèmes 
d’aménagement pour meubles. Elle propose des solutions de charnières, tiroirs 
et mécanismes d’ouverture alliant qualité, précision et durabilité. Ses produits 
sont largement utilisés dans les cuisines et le mobilier haut de gamme. 

      <br /><br />

      <strong>INOXA :</strong>  est une marque spécialisée dans les accessoires et équipements 
d’aménageme de cuisine. Elle propose des solutions pratiques et fonctionnelles 
pour l’organisation intérieure des meubles, alliant qualité, design et durabilité. 

      <br /><br />

      <strong>SALICE :</strong>  est une marque italienne spécialisée dans les ferrures et systèmes 
d’ouverture pour meubles. Elle propose des charnières, coulisses et 
mécanismes alliant innovation, précision et durabilité.
    </>
  ),
}
};

  const cards = [
    { key: "electromenagers", title: "Électroménagers", img: img1, },
    { key: "materiaux", title: "Matériaux & Pierre", img: img2, },
    { key: "accessoires", title: "Accessoires & Quincaillerie", img: img3, },
  ];

  return (
   <Box ref={sectionRef} className="Partenaires">

      {/* HEADER */}
      <div className="partenaires-header reveal-on-scroll reveal-soft delay-1">
        <span className="small-title">PARTENARIAT</span>
        <h2>ET COLLABORATIONS B TO B</h2>
        <p>
          Nous collaborons avec des experts B2B de haut niveau pour réaliser des projets 
prestigieux, en apportant des solutions de design intérieur sur mesure, alliant 
excellence, innovation et raffinement
        </p>
      </div>

      {/* PARTENAIRES */}
     <div className="partenaires-list reveal-on-scroll reveal-soft delay-2">
        {partenaires.map((p, i) => (
          <span key={i}>{p}</span>
        ))}
      </div>

      {/* FOURNISSEURS */}
      <div className="fournisseurs-header reveal-on-scroll reveal-soft delay-2">
        <span className="small-title">FOURNISSEURS ET</span>
        <h2>MARQUES</h2>
        <p>Nous collaborons avec des fournisseurs fiables pour offrir des solutions 
innovantes, durables et de haute qualité. Ces partenariats nous permettent de 
garantir des réalisations modernes, esthétiques et adaptées aux besoins des 
clients</p>
      </div>

      {/* CARDS */}
      <Grid container className="cards-grid">
      {cards.map((card, i) => (
       <Grid
  item
  xs={12}
  md={4}
  key={card.key}
  className={`reveal-on-scroll reveal-image delay-${i + 1}`}
>

            <Card className="card-item">
           
                <CardMedia
                  component="img"
                  image={card.img}
                  alt={card.title}
                  className="card-img"
                />
<button
  className="voir-btn"
  onClick={() => setActiveDialog(card.key)}
>
  <span className="voir-title">{card.title}</span>

  <div className="voir-line-wrapper">
    <span className="voir-dot"></span>
    <span className="voir-line"></span>
    <span className="voir-action">voir</span>
  </div>
</button>

               
            </Card>

       
          </Grid>
        ))}
      </Grid>

      {/* DIALOG (MUI uniquement structure) */}
      <Dialog
  open={Boolean(activeDialog)}
  onClose={() => setActiveDialog(null)}
  fullWidth
  maxWidth="md"
  className="dialog-custom"
>
  <DialogTitle className="dialog-title-custom">
    {activeDialog && dialogContent[activeDialog].title}

    <IconButton
      onClick={() => setActiveDialog(null)}
      className="dialog-close-btn"
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent className="dialog-content-custom">
   <Typography className="dialog-text-custom">
  {activeDialog && dialogContent[activeDialog].text}
</Typography>
  </DialogContent>
</Dialog>

    </Box>
  );
}